import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function docHelperErrorReducer(
	state = initialstate.documents,
	action
) {
	switch (action.type) {
		case types.DOCHELPER_ERROR:
			if (action.response) {
				return action.response.data || state;
			}
			break;
		default:
			return state;
	}
}
